const search_engine = () => {
    var select = $(".search_engine select")
    var search_engine = $(".search_engine")

    if(select.length > 0) {
        

        select.selectpicker({
            //dropupAuto: false
        });
        

        
        
    }

    /*if (search_engine.length > 0) {
        var md = new MobileDetect(window.navigator.userAgent);

        if(md.mobile()) {
            search_engine.addClass('mobile')
        }
    }*/
}

module.exports = {
    search_engine
};